require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-material-ui-pickers.json") })
        }
      }, "path---package-bs-material-ui-pickers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-material-ui-pickers!./.cache/json/package-bs-material-ui-pickers.json
// module id = 798
// module chunks = 231608221292675